export default "__VITE_ASSET__GzLf1kfS__"